import store from '@ps/store'
import qc, { Texture } from 'qc'
import { IframeWindow, QiciType } from '@ps/bridge/iframe/iframe.window.type'
import { specialNodes } from '@ps/bridge/qc/node/config'

/**
 * 该模块用来获取 iframe 中具有代表性的一些数据
 */

export function getIframe(): IframeWindow {
  return store.state.workspace.game.iframeWindow
}

function getQc() {
  return getIframe().qc
}

function getPS() {
  return getIframe().ps
}

function getQcGame(): qc.Game {
  return getQc().gameOb
}

function getUIRoot(): qc.Node {
  return getIframe().UIRoot
}

interface psOptions {
  SceneConfig: any
  Layout: any
  AudioNode: unknown
  VerticalHorizontal: unknown
  VideoEvent: {
    LOAD_COMPLETE: () => unknown
  }
  Video: any
  Audio: any
  TweenPositionArea: any
  LayoutData: any
}

export default {
  get iframe(): IframeWindow {
    return getIframe()
  },

  get isGameReady(): boolean {
    return store.state.workspace.game.gameReady
  },

  /**
   * 对应 store.state.workspace.game.data
   */
  get qc(): any {
    return getQc()
  },

  get ps(): {
    Layout: any
    AudioNode: unknown
    VerticalHorizontal: unknown
    VideoEvent: {
      LOAD_COMPLETE: () => unknown
    }
    Video: any
    Audio: any
    TweenPositionArea: any
    LayoutData: any
    VPGamePlay: any
    SceneConfig: any
    Mathf: any
    Drager: any
    MovieClip: any
    // eslint-disable-next-line
  } {
    return getPS()
  },

  /**
   * 对应 store.state.workspace.game.data.gameOb
   */
  get qcGame(): qc.Game {
    return getQcGame()
  },

  get nodePool(): qc.NodePool {
    return getQcGame().nodePool
  },

  get qici(): QiciType {
    return getIframe().qici
  },

  get assets(): qc.Assets {
    return getQcGame().assets
  },

  get texture(): Texture {
    return getQc().Texture
  },

  /**
   * 获取 UIRoot 节点
   * 对应 store.state.workspace.game.UIRoot
   */
  get UIRoot(): qc.Node {
    return getIframe().UIRoot
  },

  /**
   * 获取 gamePlay 节点
   */
  get gamePlay(): qc.Node {
    return getUIRoot().getChild(specialNodes.gamePlay.name)
  },
  // 暂停所有声音   stopAllSound
  stopAllSound(): void {
    getIframe().stopAllSound()
  },
  // 恢复所有声音
  recoveryAllSound(): void {
    getIframe().recoveryAllSound()
  },
  // 判断是否支持forceMuted,如果支持这个方法，则不需要轮询调用stopAllSound()
  stopSound(previewWindow?: IframeWindow): void {
    const iframeWindow = previewWindow || getIframe()
    typeof iframeWindow.forceMuted === 'function' &&
      iframeWindow.forceMuted(true)
  },
  recoverySound(previewWindow?: IframeWindow): void {
    const iframeWindow = previewWindow || getIframe()
    if (typeof iframeWindow.forceMuted === 'function') {
      // 脚本中监听了失去焦点事件，恢复时 soundIsPause 的值可能为true，导致无法恢复声音
      iframeWindow.soundIsPause = false
      iframeWindow.forceMuted(false)
    }
  },
  // 暂停游戏画面
  gamePaused(): void {
    getIframe().qc_game.phaser.gamePaused()
  },
  // 恢复游戏画面
  gameResumed(): void {
    getIframe().qc_game.phaser.gameResumed()
  },

  worldRelayout(): void {
    getIframe().qc_game.world.relayout()
  },

  // 判断当前素材是否是 750*1334 制作的
  get isCurrentScreen(): boolean {
    let referenceResolution: {
      x: number
      y: number
    } = {
      x: 0,
      y: 0,
    }
    if (
      // @ts-ignore
      getUIRoot().ScaleAdapter &&
      // @ts-ignore
      getUIRoot().ScaleAdapter.referenceResolution
    ) {
      // @ts-ignore
      referenceResolution = getUIRoot().ScaleAdapter.referenceResolution
    }
    return (
      (referenceResolution.x === 750 && referenceResolution.y === 1334) ||
      (referenceResolution.x === 1334 && referenceResolution.y === 750)
    )
  },

  get fontLoader() {
    return getIframe().MW_FONT_LOADER
  },

  get languagesMgr() {
    return getIframe().languagesMgr
  },

  get projectPath() {
    return getIframe().location.href.substr(
      0,
      getIframe().location.href.lastIndexOf('/'),
    )
  },

  getAbsoluteUrl(url: string): string {
    // 如果 URL 没有内容（包含空字符串和 undefined），或者是以 http 开头的，直接返回
    if (!url || url.indexOf('http') === 0) {
      return url
    }
    return `${this.projectPath}/${url}`
  },
}
